import { useEffect, useState } from "react";
import WorklistDetailsActivity from "./WorklistDetailsActivity";
import WorkilstAllocateFreshVolume from "./WorkilstAllocateFreshVolume";
import { getMasterData } from "../../../services/chartService";
import { useLocation } from "react-router-dom";
import WorklistDetailsHeader from "./WorklistDetailsHeader";
import { useNavigate } from "react-router-dom";
import { userRole } from "../../../utils/constants";

function WorklistDetails() {
  const [changeInWorklist, setChangeInWorklist] = useState(false);
  const [key, setKey] = useState(0);
  const [masterData, setMasterData] = useState();
  const [parentDetails, setParentDetails] = useState();
  const location = useLocation();
  const [query, setQuery] = useState();
  const [worklist, setWorklist] = useState();
  const worklist_id = location?.state?.worklist_id;
  const navigate = useNavigate();

  if (location?.state === null) {
    navigate("/manager-worklist");
  }

  const [isLoading, setLoadingState] = useState(true);

  useEffect(() => {
    fetchMasterData();
  }, []);

  const fetchMasterData = async () => {
    getMasterData()
      .then((response) => {
        setMasterData(response?.data);
        setLoadingState(false);
      })
      .catch((error) => {
        console.log(error);
        setLoadingState(false);
      });
  };

  const onSuccess = () => {
    setLoadingState(true);
    fetchMasterData();
  };

  useEffect(() => {
    setKey((prevKey) => prevKey + 1);
  }, [worklist_id]);

  return (
    <>
      {isLoading && (
        <>
          <div className="row">
            <div className="col-12 text-center">
              <div className="spinner-border mt-20 h-100px w-100px text-gray-400" />
            </div>
          </div>
        </>
      )}

      {!isLoading && (
        <>
          <div className="row">
            <WorklistDetailsHeader
              key={key}
              worklistId={worklist_id}
              query={query}
              setWorklist={setWorklist}
              masterData={masterData}
              onSuccess={onSuccess}
            />
          </div>
          <div className="row">
            <div className="col-xl-12 col-lg-12 col-md-12">
              <div className="row gy-5 g-xl-10">
                <WorklistDetailsActivity
                  key={key}
                  setChangeInWorklist={setChangeInWorklist}
                  changeInWorklist={changeInWorklist}
                  parentDetails={parentDetails}
                  worklistId={worklist_id}
                  masterData={masterData}
                  worklist={worklist}
                />
                {localStorage.getItem("Role") === userRole.Manager ||
                localStorage.getItem("Role") === userRole.TL ? (
                  <WorkilstAllocateFreshVolume
                    setParentDetails={setParentDetails}
                    changeInWorklist={changeInWorklist}
                    setChangeInWorklist={setChangeInWorklist}
                    worklistId={worklist_id}
                    masterData={masterData}
                    onQuery={setQuery}
                  />
                ) : (
                  ""
                )}
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
}
export default WorklistDetails;
